import type { Language } from '../state/game';

let readyLanguage: Language | null = null;

function sendReady(): void {
  if (readyLanguage !== null) navigator.serviceWorker.controller?.postMessage({ type: 'PLAY_READY', language: readyLanguage });
}

/** Called after warmup and a rendered play frame, also after a language change. */
export function cacheReadyGame(language: Language): void {
  if (!import.meta.env?.PROD || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (readyLanguage === language) return;
  readyLanguage = language;
  sendReady();
}

/** Register the worker emitted by Vite, including calls made after window.load. */
export function registerServiceWorker(): void {
  if (!import.meta.env?.PROD || typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.addEventListener('controllerchange', sendReady);
  window.addEventListener('online', sendReady);
  const register = () => {
    void navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      console.warn('[serviceWorker] registration failed:', error);
    });
  };
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
